// extracted by mini-css-extract-plugin
export default {"role":"YlN1-","roleName":"urDBL"};